<template>
  <main>
    <div>
      <gl-button @click="swapBaseAndCompare">
        対象・比較を入れ替える
      </gl-button>
    </div>
    <md-tabs
      :md-active-tab="activeTab"
      @md-changed="$emit('update:activeTab', $event)"
    >
      <md-tab id="base" md-label="対象">
        <div>
          <md-radio v-model="base.selectMode" value="category">
            分類
            <gl-sub-text>で指定</gl-sub-text>
          </md-radio>
          <md-radio v-model="base.selectMode" value="item">
            商品
            <gl-sub-text>で指定</gl-sub-text>
          </md-radio>
        </div>
        <div>
          <filter-item-category
            v-if="base.selectMode === 'category'"
            :company="company"
            v-bind.sync="base"
          />
          <filter-item
            v-if="base.selectMode === 'item'"
            :company="company"
            v-bind.sync="base"
          />
        </div>
      </md-tab>
      <md-tab id="compare" md-label="比較">
        <div>
          <md-radio v-model="compare.selectMode" value="category">
            分類
            <gl-sub-text>で指定</gl-sub-text>
          </md-radio>
          <md-radio v-model="compare.selectMode" value="item">
            商品
            <gl-sub-text>で指定</gl-sub-text>
          </md-radio>
        </div>
        <div>
          <filter-item-category
            v-if="compare.selectMode === 'category'"
            :company="company"
            v-bind.sync="compare"
          />
          <filter-item
            v-if="compare.selectMode === 'item'"
            :company="company"
            v-bind.sync="compare"
          />
        </div>
      </md-tab>
    </md-tabs>
    <div class="title">
      <gl-sub-text>出力形式</gl-sub-text>
    </div>
    <div class="content radio-buttons vertical">
      <md-radio v-model="_itemAggregation" value="sum">
        対象計表示
        <md-tooltip md-direction="bottom"
          >対象を1つのアイテムのように集計して扱います</md-tooltip
        >
      </md-radio>
      <md-radio
        v-model="_itemAggregation"
        value="detail"
        :disabled="_selectedCategoryMode"
      >
        対象明細表示
        <md-tooltip md-direction="bottom"
          >個々の対象について分析します。分類指定の場合は指定できません</md-tooltip
        >
      </md-radio>
    </div>
    <span>
      ※.指定が多すぎる場合、併買者数上位{{ maxItems }}件に絞り込まれます
    </span>
  </main>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'
import FilterItem from '@/components/FilterItem2.vue'
import FilterItemCategory from '@/components/FilterItemCategory.vue'

const MAX_ITEMS = process.env.VUE_APP_ACTINIA_MAX_ITEMS
  ? Number(process.env.VUE_APP_ACTINIA_MAX_ITEMS)
  : 1000

export default {
  components: { FilterItem, FilterItemCategory },
  mixins: [ErrorReport],
  props: {
    company: {
      type: String,
    },
    base: {
      company: {
        type: String,
        required: true,
      },
      items: {
        type: Array,
        default: () => [],
      },
      itemGroupId: {
        type: String,
      },
      categories: {
        type: Array,
        default: () => [],
      },
    },
    compare: {
      company: {
        type: String,
        required: true,
      },
      items: {
        type: Array,
        default: () => [],
      },
      itemGroupId: {
        type: String,
      },
      categories: {
        type: Array,
        default: () => [],
      },
    },
    activeTab: {
      type: String,
      default: 'base',
      validator(v) {
        return ['base', 'compare'].includes(v)
      },
    },
    itemAggregation: {
      type: String,
      default: 'sum',
    },
  },
  data() {
    return {
      /**
       * 表示商品数
       */
      maxItems: MAX_ITEMS,
    }
  },
  methods: {
    swapBaseAndCompare() {
      this.$emit('update:base', {
        ...this.compare,
        categories: this.compare.categories,
        items: this.compare.items,
        selectMode: this.compare.selectMode,
        key: new Date().getTime().toString(),
      })
      this.$emit('update:compare', {
        ...this.base,
        categories: this.base.categories,
        items: this.base.items,
        selectMode: this.base.selectMode,
        key: new Date().getTime().toString(),
      })
    },
  },
  computed: {
    _itemAggregation: {
      get() {
        if (this.compare.selectMode === 'category') {
          // 比較方法がカテゴリ指定の場合は出力形式を対象計に強制切り替え
          this.$emit('update:itemAggregation', 'sum')
          return 'sum'
        } else {
          return this.itemAggregation
        }
      },
      set(newVal) {
        this.$emit('update:itemAggregation', newVal)
      },
    },
    _selectedCategoryMode() {
      return this.compare.selectMode === 'category'
    },
    errors() {
      const errors = []
      for (let error of this.base.errors) {
        errors.push('対象：' + error)
      }
      for (let error of this.compare.errors) {
        errors.push('比較：' + error)
      }
      return errors
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  margin-top: var(--spacing-medium);
}
</style>
